/**
 * Format a numeric amount using the configured currency decimal places.
 *
 * @param {number} amount Amount to format.
 * @param {Object} currency Currency configuration.
 * @returns {string} Formatted numeric amount.
 */
export const formatCurrencyAmount = (amount, currency = {}) => {
  const configuredRounding = currency.currency_rounding
  const rounding = Math.max(
    Number(configuredRounding === null || configuredRounding === undefined
      ? 2
      : configuredRounding),
    0
  )
  const parsedAmount = Number(amount)
  const value = Number.isFinite(parsedAmount) ? parsedAmount : 0

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: rounding,
    maximumFractionDigits: rounding
  }).format(value)
}

/**
 * Format an amount with the company's default currency.
 *
 * @param {number} amount Amount to format.
 * @param {Object} currency Default currency configuration.
 * @returns {string} Formatted currency amount.
 */
export const formatCurrency = (amount, currency = {}) => {
  const formattedValue = formatCurrencyAmount(amount, currency)
  const symbol = currency.currency_symbol === 'R'
    ? '៛'
    : currency.currency_symbol || currency.currency_code || ''
  const isRielCurrency = currency.currency_code === 'KHR' || symbol === '៛'

  if (!symbol) return formattedValue

  return isRielCurrency
    ? `${formattedValue} ${symbol}`
    : `${symbol} ${formattedValue}`
}

/**
 * Format an exchange-rate value for the POS header.
 *
 * @param {number} rate Exchange-rate value.
 * @returns {string} Formatted exchange rate.
 */
export const formatExchangeRate = rate => {
  const value = Number(rate)

  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 6
  }).format(Number.isFinite(value) ? value : 0)
}
